import { render } from "./UserVault.vue?vue&type=template&id=4407d758&scoped=true"
import script from "./UserVault.vue?vue&type=script&lang=js"
export * from "./UserVault.vue?vue&type=script&lang=js"

import "./UserVault.vue?vue&type=style&index=0&id=4407d758&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4407d758"]])

export default __exports__